import React from 'react';
import { ProviderIgnoredRequestsTable } from './ProviderIgnoredRequestsTable';

export const ProviderIgnoredRequestsList: React.FC = () => {
  return <ProviderIgnoredRequestsTable />;
};
